import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import quickMessageReducer from './quickMessageSlice';
import departmentReducer from './departmentSlice';
import blockRuleReducer from './blockRuleSlice';
import roomReducer from './roomSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    quickMessage: quickMessageReducer,
    department: departmentReducer,
    blockRule: blockRuleReducer,
    room: roomReducer,
  },
});

export default store;
